const REQUIRED_FIELD_ERROR_TEXT = '* This value is required';
const FIELD_VALIDATION_CONFIG = {
  Contact: {
    firstName: {
      isRequired: true,
      pattern: null,
      errorMessage: REQUIRED_FIELD_ERROR_TEXT,
    },
    businessPhone: {
      isRequired: false,
      pattern: /^[0-9]+$/,
      errorMessage: 'The phone must contain only numbers',
    },
    lastName: {
      isRequired: true,
      pattern: null,
      errorMessage: REQUIRED_FIELD_ERROR_TEXT,
    },
    email: {
      isRequired: false,
      pattern: /^\S+@\S+\.\S+$/,
      errorMessage: 'There must be a valid email address',
    },
    mobilePhone: {
      isRequired: true,
      pattern: /^[0-9]+$/,
      errorMessage: 'The phone must contain only numbers',
    },
  },
  Account: {
    accountName: {
      isRequired: true,
      pattern: null,
      errorMessage: REQUIRED_FIELD_ERROR_TEXT,
    },
    phone: {
      isRequired: true,
      pattern: /^[0-9]+$/,
      errorMessage: 'The phone must contain only numbers',
    },
  },
  Case: {
    caseTitle: {
      isRequired: true,
      pattern: null,
      errorMessage: REQUIRED_FIELD_ERROR_TEXT,
    },
  },
  Lead: {
    firstName: {
      isRequired: true,
      pattern: null,
      errorMessage: REQUIRED_FIELD_ERROR_TEXT,
    },
    lastName: {
      isRequired: true,
      pattern: null,
      errorMessage: REQUIRED_FIELD_ERROR_TEXT,
    },
    businessPhone: {
      isRequired: false,
      pattern: /^[0-9]+$/,
      errorMessage: 'The phone must contain only numbers',
    },
    mobilePhone: {
      isRequired: true,
      pattern: /^[0-9]+$/,
      errorMessage: 'The phone must contain only numbers',
    },
    email: {
      isRequired: false,
      pattern: /^\S+@\S+\.\S+$/,
      errorMessage: 'There must be a valid email address',
    },
  },
  Opportunity: {
    topic: {
      isRequired: true,
      pattern: null,
      errorMessage: REQUIRED_FIELD_ERROR_TEXT,
    },
  },
};

export const validateFormData = (formData, errors, objectFormConfig) => {
  let isOk = true;

  Object.entries(objectFormConfig).forEach(([field, config]) => {
    const errorMessage = getErrorIfNotValid(formData[field], config);
    if (errorMessage) {
      errors[field] = errorMessage;
      isOk = false;
    }
  });

  return isOk;
};

export const getErrorIfNotValid = (fieldValue, fieldConfig) => {
  let errorMessage = '';
  const trimmedValue = fieldValue.trim();

  if (fieldConfig?.isRequired && !trimmedValue) {
    errorMessage = REQUIRED_FIELD_ERROR_TEXT;
  } else if (
    fieldValue &&
    !!fieldConfig?.pattern &&
    !fieldConfig?.pattern?.test?.(fieldValue)
  ) {
    errorMessage = fieldConfig?.errorMessage || '';
  }

  return errorMessage;
};

export const getFieldValidationConfigForObject = (objectName) =>
  FIELD_VALIDATION_CONFIG[objectName];
